import AuditEventsPage from "../../pages/system/auditEvents/AuditEventsPage";

const route = {
  key: "auditEvents",
  path: "/system/audit-events",
  component: AuditEventsPage,
  permission: "system.audit.read",
  private: true,
  layout: "main",
  icon: "faHistory",
  group: "system",
  order: 90
};

export default route;
